import {
  Box, Button, Collapse, Stack, Typography,
} from '@mui/material';
import CateringProvider from 'components/CateringProvider';
import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import { AddressContext, CartContext } from 'constants/contexts';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import { pluralize } from 'utils/string';

function OrderDetails(props) {
  const cart = useContext(CartContext);
  const { currentAddress, openModal } = useContext(AddressContext);
  const catering = CateringProvider.useCatering();

  return (
    <Stack
      sx={{
        backgroundColor: 'grey.100', borderRadius: '16px 16px 0 0', p: 2, pb: 0,
      }}
      {...props}
    >
      <Stack direction="row" gap={1} mb={1}>
        <Button
          startIcon={<Icon name="motor-filled" />}
          variant={cart.hasDelivery ? 'contained' : 'text'}
          size="small"
          fullWidth
          onClick={() => cart.set({ hasDelivery: true })}
        >
          <Typography variant="label-md" fontWeight={700}>Delivery</Typography>
        </Button>
        <Button
          startIcon={<Icon name="walk-filled" />}
          variant={!cart.hasDelivery ? 'contained' : 'text'}
          size="small"
          fullWidth
          onClick={() => cart.set({ hasDelivery: false })}
        >
          <Typography variant="label-md" fontWeight={700}>Pickup</Typography>
        </Button>
      </Stack>
      <Collapse in={cart.hasDelivery}>
        <InfoRow
          title="Address"
          value={currentAddress?.label}
          onClick={() => setTimeout(openModal, 500)}
          icon="location-filled"
        />
      </Collapse>
      <InfoRow
        title="Date and time"
        value={cart.scheduledTime && dayjs(cart.scheduledTime).format('ddd, MMM DD · hh:mm A')}
        onClick={() => setTimeout(catering.openScheduling, 500)}
        icon="calendar-hour-outlined"
        error={cart.schedulingError}
      />
      <InfoRow
        title="Headcount"
        value={catering.headcount && `${catering.headcount} ${pluralize('person', catering.headcount)}`}
        onClick={() => setTimeout(catering.openHeadcount, 500)}
        icon="user-group-outlined"
      />

    </Stack>
  );
}
function InfoRow({
  title, value, icon, error, ...props
}) {
  const getIcon = () => {
    const slices = icon.split('-');
    slices[slices.length - 1] = value ? 'filled' : 'outlined';
    return slices.join('-');
  };
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      height: error ? '60px' : '48px',
    }}
    >
      <Stack width="100%">
        <Typography variant="body-caption" color="error.darker">{error}</Typography>
        <Stack direction="row" justifyContent="space-between" sx={{ cursor: 'pointer' }} {...props}>
          <Stack direction="row" alignItems="center" gap={1} color={error ? 'error.darker' : 'inherit'}>
            <Icon size={24} name={getIcon()} />
            <Typography variant="title-sm">{value || title}</Typography>
          </Stack>
          {!value ? (
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Typography variant="body-md">Select</Typography>
              <Icon name="arrow-right" />
            </Stack>
          ) : (<IconButton name="edit-outlined" />)}
        </Stack>
      </Stack>
    </Box>

  );
}
export default OrderDetails;
